export default "__VITE_ASSET__ABKOAlzk__"